import { extract } from 'query-string';

export const chatbotDefaultValues = {
  name: '',
  companyKey: '',
  companyId: 0,
  businessType: '',
  businessSubType: [],
  webSiteUrl: [''],
  selectedUrls: {
    businessBackgroundLinks: [],
    businessServicesLinks: [],
    contactInfoLinks: [],
    otherLinks: [],
    businessAddressLinks: []
  },
  extractedInfo: null,
  lastExtractedUrl: ''
};

export const extractVariableNodeDefaultVariableValues = {
  name: '',
  description: '',
  type: 1
};

export const apiNodeDefaultValues = {
  apiMethod: 'GET',
  apiUrl: '',
  apiBodyTemplate: {},
  apiHeaders: {},
  queryParams: {},
  responseMapping: {},
  responseFact: '',
  successWhenContains: '',
  successWhenStatus: null,
  timeout: 120000,
  apiBodyType: 'json'
};
